export default "__VITE_ASSET__BUR1aVml__"